import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Image from '../../image/image';
import Heading from '../../heading/heading';

const ImageBlock = ({ paddingTop, paddingBottom, image, bg }) => {
  return (
    <Container bg={bg} gutters>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        <Image image={image} />
      </Spacing>
    </Container>
  );
};

export default ImageBlock;

export const query = graphql`
  fragment ImageBlock on DatoCmsImageBlock {
    id: originalId
    paddingTop
    paddingBottom
    image {
      gatsbyImageData(layout: FULL_WIDTH, imgixParams: { fit: "crop", w: "1000" })
    }

    __typename
  }
`;
